/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Row, Col, Typography, Button, Input, Select } from 'antd';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import SearchPagerRight from 'shared_components/search_pager_right';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import { PlusCircleOutlined, ExclamationCircleOutlined} from '@ant-design/icons';
import { EditableRow } from './editableFormRow';
import { EditableCell } from './editableCell';
import { numberFormat, formatValueOnChange } from 'utils/helper';
import Message from 'shared_components/message';
import { TABLE_HEADER_STYLE, TABLE_CELL_STYLE, TABLE_PAGINATION_STYLE } from 'utils/tableStyles';

import { fetchUnitsListAPI } from 'services/shared/fetchLovList';
import { UserAccessContext } from 'context/userAccess';
import { index } from 'd3-array';
// import { fontFamily } from '@mui/system';

const { TextArea } = Input;

function DeliveryDataTable({ handleTableData, handleTotVal, drData, drDetails, disabled, messagesList, handleDeleteList, edit }) {
    const { userAccess } = useContext(UserAccessContext);
    const updateDRRight = userAccess['deliveryReceipt'].update;
    const createDRRight = userAccess['deliveryReceipt'].create;
	
	const [tableData, setTableData] = useState([]);
	const [page, setPage] = useState(0);
	const [fromDeliveryDetData, setFromDeliveryDetData] = useState([]);
	const [fromAddData, setFromAddData] = useState([]);
	const [count, setCount] = useState(0);
	const [pageSize, setPageSize] = useState(5);

	const [editableTableVal, setEditableTableVal] = useState(true);
    const [msgList, setMsgList] = useState([]);
	const [unitName ,setUnitName] = useState('');
	const [unitsList,setUnitsList] = useState([]);
	const [editingValues, setEditingValues] = useState({});

	

	// refs to avoid calling setState/parent callback in a loop
	const prevTableDataRef = useRef(null);
	const prevSentDataRef = useRef(null);

	const unitsOptions = unitsList.map((unit, index) => ({
		key: index,
		label: unit.unit_name,
		value: unit.unit_name
	}));

		// Ensure LOV (units) loads on mount so Select has options immediately
		useEffect(() => {
				getLOVList();
		}, []);

	async function getLOVList(){
		try{
			const getUnit = await fetchUnitsListAPI();
			setUnitName(getUnit[0].unit_name);
			setUnitsList(getUnit);
		}catch(error){
			console.log("error", error);
		}
	};

	useEffect(() => {
		if(edit){
			setEditableTableVal(edit)
		}
	}, [edit])

	useEffect(() => {
		function fetchData() {
			// Ensure each drDetail has a unique stable key based on dr_line_id
			const detailsWithKeys = drDetails.map(detail => ({
				...detail,
				key: detail.dr_line_id !== undefined ? detail.dr_line_id : detail.key
			}));
			setFromDeliveryDetData(detailsWithKeys);
		}
		fetchData();
	}, [drDetails]);

	useEffect(() => {
		function fetchData() {
			setMsgList(messagesList); // message list used for messages popup

			getLOVList();
		}
		fetchData();
	}, [messagesList]);

	// set state for table data to handle data from dr list, add button, and from invoice details
	useEffect(() => {
		

		// combine source arrays
		let combineData = [];
		combineData.push(...fromDeliveryDetData, ...fromAddData);


		// NO MERGING - Keep all rows separate for proper duplicate validation
		const arr = combineData;
		console.log('arr => ', arr);

		const resultTblData = arr.map((o, index) => ({
			...o,
			// Ensure each row has unique key
			key: o.key !== undefined ? o.key : `unique_${index}`,
		}));

		console.log('resultTblData =>', resultTblData);

		const formatResultTblData = resultTblData.map(o => {
			return {
				...o,
				quantity: formatValueOnChange((o.quantity || '0').toString(), 'numeric'),
				unit_price: numberFormat(parseFloat((o.unit_price || '0').toString().replace(/,/g, '')), 2),
				amount: numberFormat(parseFloat((o.amount || '0').toString().replace(/,/g, '')), 2),
				unit_code: o.unit_code || '',
				unit_name: o.unit_name || ''
			};
		});
		// -- merging end

		console.log('formatResultTblData =>', formatResultTblData);

		// avoid unnecessary state updates by comparing serialized data
		const serialized = JSON.stringify(formatResultTblData);
		if(prevTableDataRef.current !== serialized){
			setTableData(formatResultTblData); // set table data with the merged table lines
			prevTableDataRef.current = serialized;
		}

		if(prevSentDataRef.current !== serialized){
			console.log('📊 Sending updated table data to parent:', formatResultTblData.map(d => ({key: d.key, dr_line_id: d.dr_line_id, line_description: d.line_description})));
			handleTableData(formatResultTblData); // set the merged data to be returned to the parent component
			prevSentDataRef.current = serialized;
		}

		if(disabled){
			setEditableTableVal(false);
		}

		if(updateDRRight === 'FALSE'){
			setEditableTableVal(false);
		}

		if(edit || [createDRRight, updateDRRight].includes('TRUE')){
			setEditableTableVal(true);
		}
	}, [fromAddData, fromDeliveryDetData, createDRRight, disabled, edit, handleTableData, updateDRRight]);

	//handle invoice total amount
	const selectDeliveryamt = tableData.map(amt => 
		parseFloat(amt.amount.toString().replace(/,/g, '')) ? parseFloat(amt.amount.toString().replace(/,/g, '')) : 0.00
	);
	const totDeliveryAmt = selectDeliveryamt.reduce((result, amt) => result + amt, 0.00);
	handleTotVal(totDeliveryAmt);

	// add delivery line - add button functionality
	const handleAdd = () => {
		const newAddData = {
			key: count,
			line_description: '-',
			quantity: '0',
			// unit_name: unitName,
			unit_name: '-',
			unit_price: '0.00',
			//rebate: '0',
			amount: '0.00',
		};

		const addDataRet = fromAddData.filter((items) => items.line_description === '-'); // control add button clicks
		if(addDataRet.length < 2){
			setFromAddData([...fromAddData, newAddData]);
			setCount(count + 1);
			
			// Navigate to last page to show the new record
			const newTotalRecords = tableData.length + 1;
			const lastPage = Math.max(0, Math.ceil(newTotalRecords / pageSize) - 1);
			setPage(lastPage);
		}
	};

	// Handler for cell value changes
	const handleCellChange = (key, dataIndex, value, record) => {
		

		console.log('dataIndex =>', dataIndex);
		console.log('value => ', value);
		console.log('record =>', record);

		// If updating unit_code or unit_name, update all underlying rows that share the same description
		if (dataIndex === 'unit_code' || dataIndex === 'unit_name') {
			const matchDesc = record.line_description;
			// normalize values
			let newUnitCode = dataIndex === 'unit_code' ? String(value) : String(record.unit_code || '');
			let newUnitName = '';
			if (dataIndex === 'unit_name') {
				newUnitName = value;
				// Find the corresponding unit_code for this unit_name
				const unit = unitsList.find(u => u.unit_name === value);
				newUnitCode = unit ? String(unit.unit_code) : String(record.unit_code || '');
			} else {
				const unit = unitsList.find(u => String(u.unit_code) === String(value));
				newUnitName = unit ? unit.unit_name : record.unit_name;
			}

			setFromAddData(prev => prev.map(item => (
				item.line_description === matchDesc ? { ...item, unit_code: newUnitCode, unit_name: newUnitName } : item
			)));

			setFromDeliveryDetData(prev => prev.map(item => (
				item.line_description === matchDesc ? { ...item, unit_code: newUnitCode, unit_name: newUnitName } : item
			)));

			// Trigger validation for unit change
			const updatedRecord = { ...record, unit_code: newUnitCode, unit_name: newUnitName };
			handleSave(updatedRecord, { unit_name: newUnitName });

			return;
		}

		// Otherwise, update single row (preserve previous semantics)
		let updated = false;
		setFromAddData(prev => {
			const next = prev.map(item => {
				if (item.key === key) { updated = true; return { ...item, [dataIndex]: value }; }
				return item;
			});
			return next;
		});
		if (updated) return;
		setFromDeliveryDetData(prev => prev.map(item => (item.key === key ? { ...item, [dataIndex]: value } : item)));
	};

	// helper: find the most current row object by key from any source
	const getCurrentRow = (key) => {
		const fromAdd = fromAddData.find(r => r.key === key);
		if (fromAdd) return fromAdd;
		const fromDet = fromDeliveryDetData.find(r => r.key === key);
		if (fromDet) return fromDet;
		return tableData.find(r => r.key === key) || null;
	};

	function handleDelDrDet(record){
		console.log('🗑️ Deleting record:', record);

		// Use unique key to filter instead of line_description to handle duplicates correctly
		const newAddData = fromAddData.filter(item => item.key !== record.key);// data from add button
		const newDeliveryData = fromDeliveryDetData.filter(item => item.key !== record.key);// data drDetails

		setFromAddData(newAddData);
		setFromDeliveryDetData(newDeliveryData);

		// Adjust page if current page becomes empty after deletion
		const newTableData = tableData.filter(item => item.key !== record.key);
		const newTotalRecords = newTableData.length;
		const maxPage = Math.max(0, Math.ceil(newTotalRecords / pageSize) - 1);
		if (page > maxPage) {
			setPage(maxPage);
		}

		if(record.dr_line_id !== undefined){
			console.log('🗑️ Adding to delete list - dr_line_id:', record.dr_line_id);
			handleDeleteList(record);
		} else {
			console.log('⚠️ Record has no dr_line_id, skipping delete list (newly added item)');
		};
	};

	// handle the save function from editable Cell
	const handleSave = (row, val) => {
		const m0020 = msgList.filter((items) => items.message_code === 'M0020');
		
		// Get current data directly from both sources to ensure we have the latest data
		const allCurrentData = [...fromDeliveryDetData, ...fromAddData];
		// Check for duplicate transaction lines: same line description + unit + unit price
		const currentLineDescription = val.line_description === undefined ? row.line_description : val.line_description;
		const currentUnitName = val.unit_name === undefined ? row.unit_name : val.unit_name;
		const currentUnitPrice = val.unit_price === undefined ? row.unit_price : val.unit_price;
		
		const tblDataRet = allCurrentData.filter((items) => {
			if (items.key === row.key) return false; // Exclude current row being edited
			
			// Normalize line description comparison (case insensitive, trim whitespace)
			const itemLineDesc = (items.line_description || '').toString().trim().toLowerCase();
			const currentLineDesc = (currentLineDescription || '').toString().trim().toLowerCase();
			
			// Normalize unit name comparison (case insensitive, trim whitespace)
			const itemUnitName = (items.unit_name || '').toString().trim().toLowerCase();
			const currentUnitNameNorm = (currentUnitName || '').toString().trim().toLowerCase();
			
			// Normalize unit price comparison (convert to numbers with 2 decimal places)
			const itemPrice = parseFloat((items.unit_price || '0').toString().replace(/,/g, ''));
			const currentPrice = parseFloat((currentUnitPrice || '0').toString().replace(/,/g, ''));
			
			const lineMatch = itemLineDesc === currentLineDesc;
			const unitMatch = itemUnitName === currentUnitNameNorm;
			const priceMatch = Math.abs(itemPrice - currentPrice) < 0.01; // Allow small floating point differences
			
			return lineMatch && unitMatch && priceMatch;
		});

		console.log('🚀 ~ handleSave ~ Duplicate validation:');
		console.log('🚀 ~ Current row key:', row.key);
		console.log('🚀 ~ Current line_description:', `"${currentLineDescription}"`);
		console.log('🚀 ~ Current unit_name:', `"${currentUnitName}"`);
		console.log('🚀 ~ Current unit_price:', `"${currentUnitPrice}"`);
		console.log('🚀 ~ fromDeliveryDetData:', fromDeliveryDetData.map(item => ({key: item.key, line_description: `"${item.line_description}"`, unit_name: `"${item.unit_name}"`, unit_price: `"${item.unit_price}"`})));
		console.log('🚀 ~ fromAddData:', fromAddData.map(item => ({key: item.key, line_description: `"${item.line_description}"`, unit_name: `"${item.unit_name}"`, unit_price: `"${item.unit_price}"`})));
		console.log('🚀 ~ All current data:', allCurrentData.map(item => ({key: item.key, line_description: `"${item.line_description}"`, unit_name: `"${item.unit_name}"`, unit_price: `"${item.unit_price}"`})));
		console.log('🚀 ~ Matching duplicates found:', tblDataRet);
		console.log('🚀 ~ tblDataRet.length:', tblDataRet.length);
		
		// Debug each comparison step with normalized values
		allCurrentData.forEach((item, index) => {
			if (item.key !== row.key) {
				const itemLineDesc = (item.line_description || '').toString().trim().toLowerCase();
				const currentLineDesc = (currentLineDescription || '').toString().trim().toLowerCase();
				const itemUnitName = (item.unit_name || '').toString().trim().toLowerCase();
				const currentUnitNameNorm = (currentUnitName || '').toString().trim().toLowerCase();
				const itemPrice = parseFloat((item.unit_price || '0').toString().replace(/,/g, ''));
				const currentPrice = parseFloat((currentUnitPrice || '0').toString().replace(/,/g, ''));
				
				const lineMatch = itemLineDesc === currentLineDesc;
				const unitMatch = itemUnitName === currentUnitNameNorm;
				const priceMatch = Math.abs(itemPrice - currentPrice) < 0.01;
				
				console.log(`🔍 Item ${index}: normalized line_desc="${itemLineDesc}" vs "${currentLineDesc}" = ${lineMatch}, unit="${itemUnitName}" vs "${currentUnitNameNorm}" = ${unitMatch}, price=${itemPrice} vs ${currentPrice} = ${priceMatch}`);
			}
		});

		if(tblDataRet.length < 1 && currentLineDescription !== '-'){
			// if data comes from delivery details list ----------------------------------------
			const checkDrDetData = [...fromDeliveryDetData];
			const drDetIndex = checkDrDetData.findIndex(item => row.key === item.key);

			if(drDetIndex >= 0){
				const drDetItem = checkDrDetData[drDetIndex];
				// set table column amount value
				if(
					row.quantity.toString() !== drDetItem.quantity.toString()
					|| row.unit_price.toString() !== drDetItem.unit_price.toString()
				){
					const row_amount = parseFloat(row.quantity.toString().replace(/,/g, ''))
									*parseFloat(row.unit_price.toString().replace(/,/g, ''));
					
					row.amount = numberFormat(row_amount, 2);
				}
				// set data table row update
				checkDrDetData.splice(drDetIndex, 1, { ...drDetItem, ...row });
				setFromDeliveryDetData(checkDrDetData);
			};

			// if data comes from add button ----------------------------------------
			const checkAddData = [...fromAddData]
			const addDataIndex = checkAddData.findIndex(item => row.key === item.key);
			
			if(addDataIndex >= 0){
				const addDataItem = checkAddData[addDataIndex];
				// set table column amount value
				if(
					row.quantity.toString() !== addDataItem.quantity.toString()
					|| row.unit_price.toString() !== addDataItem.unit_price.toString() 
				){
					const row_amount = parseFloat(row.quantity.toString().replace(/,/g, ''))
									*parseFloat(row.unit_price.toString().replace(/,/g, ''));

					row.amount = numberFormat(row_amount, 2);
				}
				// set data table row update
				checkAddData.splice(addDataIndex, 1, { ...addDataItem, ...row });
				setFromAddData(checkAddData);
			};
		}else if (tblDataRet.length > 0 && currentLineDescription !== '-'){
			Message.error({ message: 'Transaction line already exist!' });
			
			// Clear the line_description field after showing error
			const clearLineDescription = (dataArray, setDataArray) => {
				const index = dataArray.findIndex(item => item.key === row.key);
				if (index >= 0) {
					const newData = [...dataArray];
					newData[index] = { ...newData[index], line_description: '-' };
					setDataArray(newData);
				}
			};
			
			// Clear line_description from both data sources
			clearLineDescription(fromAddData, setFromAddData);
			clearLineDescription(fromDeliveryDetData, setFromDeliveryDetData);
		};
	};


	const columns = [
		{ title: 'QUANTITY', dataIndex: 'quantity', width: '15%' },
		{ title: 'UNIT', dataIndex: 'unit_name', width: '15%' },
		{ title: 'LINE DESCRIPTION', dataIndex: 'line_description', width: '35%' },
		{ title: 'UNIT PRICE', dataIndex: 'unit_price', width: '15%' },
		{ title: 'AMOUNT', dataIndex: 'amount', width: '15%' },
		{ title: 'OPERATION', dataIndex: 'operation', width: '5%' },
	];


	// Pagination logic
	const pagedData = tableData.slice(page * pageSize, page * pageSize + pageSize);



	return (
		<div>
			<Row style={{ marginTop: 5 }}>
				<Col span={12}>
					<Button
						onClick={handleAdd}
						type="primary"
						style={{ marginTop: 5 }}
						icon={<PlusCircleOutlined />}
						disabled={[updateDRRight, createDRRight].includes('TRUE') ? disabled : true}
					>
						ADD DR LINE
					</Button>
				</Col>
				<Col span={12}>
					<SearchPagerRight pageTotal={tableData.length} pageSize={pageSize} />
				</Col>
			</Row>
			<Row gutter={[8, 1]} justify="center">
				<Col span={24}>
					<TableContainer component={Paper} style={{ marginTop: 8 }}>
						<Table size="small">
							<TableHead>
								<TableRow>
									{columns.map(col => (
										<TableCell key={col.dataIndex} style={{ ...TABLE_HEADER_STYLE, width: col.width }}>
											{col.title}
										</TableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody style={{ textTransform: 'uppercase' }}>
								{pagedData.map((record, idx) => (
									<TableRow key={record.key || idx} className="editable-row">
										{columns.map(col => (
											<TableCell key={col.dataIndex} style={TABLE_CELL_STYLE}>
 												{col.dataIndex === 'operation' ? (
 													<Typography.Link title="Sure to delete?" onClick={() => handleDelDrDet(record)}
 														disabled={edit ? false : [updateDRRight, createDRRight].includes('TRUE') ? disabled : true}
 													>
 														Delete
 													</Typography.Link>
 												) : col.dataIndex === 'line_description' ? (
													(() => {
														const editingKey = `${record.key}_line_description`;
														const displayValue = editingValues[editingKey] !== undefined ? editingValues[editingKey] : record.line_description;

														return (
															<TextArea className='editableCellInput'
																value={displayValue}
																maxLength={750}
																onChange={e => {
																	try {
																		if (e && e.target && e.target.value !== undefined) {
																			const value = e.target.value;
																			setEditingValues(prev => ({ ...prev, [editingKey]: value }));
																		}
																	} catch (error) {
																		console.log('onChange error caught:', error);
																	}
																}}
																onBlur={e => {
																	e.preventDefault();
																	e.stopPropagation();
																	if (e && e.target) {
																		const value = e.target.value;
																		handleCellChange(record.key, 'line_description', value, record);
																		// Use setTimeout to avoid state collision during rapid typing
																		setTimeout(() => {
																			const cur = getCurrentRow(record.key);
																			if(cur) handleSave({...cur, line_description: value}, { line_description: value });
																		}, 10);
																	}
																	setEditingValues(prev => ({ ...prev, [editingKey]: undefined }));
																}}
																onKeyDown={e => {
																	if (e.key === 'Enter') {
																		e.preventDefault();
																		e.stopPropagation();
																	}
																}}
																disabled={edit ? false : [updateDRRight, createDRRight].includes('TRUE') ? disabled : true}
															/>
														);
													})()
 												) : col.dataIndex === 'unit_name' ? (
													<Select
														className='editableCellInput'
														value={record.unit_name}
														onChange={(value) => { 
														handleCellChange(record.key, 'unit_name', value, record); }}
														placeholder="Select Unit"
														style={{
															width: '100%',
															fontSize: '14px',
															fontFamily: 'Karla, sans-serif'
														}}
														options={unitsOptions}
														disabled={edit ? false : [updateDRRight, createDRRight].includes('TRUE') ? disabled : true}
													/>
 												) : col.dataIndex === 'quantity' ? (
													(() => {
														const editingKey = `${record.key}_quantity`;
														const displayValue = editingValues[editingKey] !== undefined ? editingValues[editingKey] : record.quantity;
														
														return (
															<Input className='editableCellInput' 
																value={displayValue}
																onChange={e => { 
																	try {
																		if (e && e.target && e.target.value !== undefined) {
																			const value = e.target.value;
																			setEditingValues(prev => ({ ...prev, [editingKey]: value }));
																		}
																	} catch (error) {
																		console.log('onChange error caught:', error);
																	}
																}}
																onBlur={e => {
																	e.preventDefault();
																	e.stopPropagation();
																	if (e && e.target) {
																		const value = e.target.value;
																		handleCellChange(record.key, 'quantity', value, record);
																		// Use setTimeout to avoid state collision during rapid typing
																		setTimeout(() => {
																			const cur = getCurrentRow(record.key); 
																			if(cur) handleSave({...cur, quantity: value}, { quantity: value });
																		}, 10);
																	}
																	setEditingValues(prev => ({ ...prev, [editingKey]: undefined }));
																}}
																onKeyDown={e => {
																	if (e.key === 'Enter') {
																		e.preventDefault();
																		e.stopPropagation();
																	}
																}}
																disabled={edit ? false : [updateDRRight, createDRRight].includes('TRUE') ? disabled : true}
															/>
														);
													})()
 												) : col.dataIndex === 'unit_price' ? (
													(() => {
														const editingKey = `${record.key}_unit_price`;
														const displayValue = editingValues[editingKey] !== undefined ? editingValues[editingKey] : record.unit_price;
														
														return (
															<Input className='editableCellInput' 
																value={displayValue}
																onFocus={e => { 
																	// Select all text when focused
																	if (e && e.target) {
																		e.target.select();
																	}
																}}
																onChange={e => { 
																	try {
																		if (e && e.target && e.target.value !== undefined) {
																			const value = e.target.value;
																			setEditingValues(prev => ({ ...prev, [editingKey]: value }));
																		}
																	} catch (error) {
																		console.log('onChange error caught:', error);
																	}
																}}
																onBlur={e => {
																	e.preventDefault();
																	e.stopPropagation();
																	if (e && e.target) {
																		const value = e.target.value;
																		handleCellChange(record.key, 'unit_price', value, record);
																		// Use setTimeout to avoid state collision during rapid typing
																		setTimeout(() => {
																			const cur = getCurrentRow(record.key); 
																			if(cur) handleSave({...cur, unit_price: value}, { unit_price: value });
																		}, 10);
																	}
																	setEditingValues(prev => ({ ...prev, [editingKey]: undefined }));
																}}
																onKeyDown={e => {
																	if (e.key === 'Enter') {
																		e.preventDefault();
																		e.stopPropagation();
																	}
																}}
																disabled={edit ? false : [updateDRRight, createDRRight].includes('TRUE') ? disabled : true}
															/>
														);
													})()
 												) : col.dataIndex === 'amount' ? (
 													<Input className='editableCellInput' value={record.amount}
														onChange={e => handleCellChange(record.key, 'amount', e.target.value, record)}
														onKeyDown={e => {
															if (e.key === 'Enter') {
																e.preventDefault();
																e.stopPropagation();
															}
														}}
														// onBlur remains intentionally commented out
														disabled={edit ? false : [updateDRRight, createDRRight].includes('TRUE') ? disabled : true}
 													/>
 												) : null}
											</TableCell>
										))}
									</TableRow>
								))}
								{pagedData.length === 0 && (
									<TableRow>
										<TableCell colSpan={columns.length} align="center" style={{...TABLE_CELL_STYLE, textTransform: 'none'}}>
											No records found
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
					</TableContainer>
					<TablePagination
							component="div"
							rowsPerPageOptions={[]}
							count={tableData.length}
							rowsPerPage={pageSize}
							page={page}
							onChangePage={(_, newPage) => setPage(newPage)}
							onChangeRowsPerPage={e => { setPage(0); setPageSize(parseInt(e.target.value, 10)); }}
							style={TABLE_PAGINATION_STYLE}
						/>
				</Col>
			</Row>
		</div>
	);
}

export default DeliveryDataTable;